import "./index.scss";

const DeleteUser = (props) => {
  const { deleteUserDetails, handleDeleteCancel, handleDeleteConfirm } = props;

  return (
    <div className="delete-modal">
      <h1>Delete User</h1>

      <div className="subtitle">
        Are you sure you want to delete{" "}
        <span className="subtitle-name"> {deleteUserDetails?.name}</span>?
      </div>

      <div className="delete-modal__actions">
        <button
          className="delete-modal__btn delete-modal__btn--cancel"
          onClick={handleDeleteCancel}
        >
          Cancel
        </button>
        <button
          className="delete-modal__btn delete-modal__btn--confirm"
          onClick={() => handleDeleteConfirm(deleteUserDetails)}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default DeleteUser;
